import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { setWebsitename, setWebsiteurl, setWebsiteBio, selectTemplate } from '../../actions/website-action'

import { setActivitiesOpen, setCustomization, setLinks, setAboutContent, setAboutContentRaw, setImages } from '../../actions/create-action'

import { setUser, setRoute, setSignin } from '../../actions/user-action'

import WebsiteSettings from './Settings/WebsiteSettings'

import GeneralSettings from './Settings/GeneralSettings'

import ChangePassword from './Settings/ChangePassword'

import ChangeTheme from './Settings/ChangeTheme'

import Verify from './Verify'

import { store } from '../../store'

import {Grid, Row, Col} from 'react-bootstrap'
import Navigation from '../Navigation/Navigation'

import Footer from '../Footer/Footer'

import Menu from '../Navigation/Menu'

import Signin from '../Signin/Signin'

import Rolling from '../../Images/rolling.svg';

const mapStateToProps = (state) => {
  let user = state.user.user
  let isSignedIn = state.user.isSignedIn
  let route = state.user.route
  let website = state.website
  let open = state.activities.open
  let customization = state.customization
  let about = state.about
  let links = state.links
  let images = state.images
  return {
    user: user,
    isSignedIn: isSignedIn,
    route: route,
    website: website,
    open: open,
    customization: customization,
    about: about,
    links: links,
    images: images
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onUser: (user) => dispatch(setUser(user)),
    onWebsiteName: (name) => dispatch(setWebsitename(name)),
    onImages: (image) => dispatch(setImages(image)),
    onWebsiteUrl: (url) => dispatch(setWebsiteurl(url)),
    onWebsiteBio: (bio) => dispatch(setWebsiteBio(bio)),
    onTemplate: (theme) => dispatch(selectTemplate(theme)),
    onLinks: (links) => dispatch(setLinks(links)),
    onCustomization: (custom) => dispatch(setCustomization(custom)),
    onOpen: (open) => dispatch(setActivitiesOpen(open)),
    onAboutContent: (aboutcontent) => dispatch(setAboutContent(aboutcontent)),
    onAboutContentRaw: (rawcontent) => dispatch(setAboutContentRaw(rawcontent)),
    onRouteChange: (route) => dispatch(setRoute(route)),
    onSignin: (signin) => dispatch(setSignin(signin))
  }
}

class Dashboard extends React.Component {
    constructor(props) {
    super(props)
    this.state = {
      menu: false,
      isDashboard: true,
      toMake: false,
      clickInside: false,
      websiteStatus: '',
      tokenValid: false,
      htmlpage: null
    }
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.onMenu = this.onMenu.bind(this)
}
componentDidMount() {
  if(store.getState().user.isSignedIn) {
  this.props.onRouteChange('dashboard')
  }
  document.addEventListener('mousedown', this.handleClickOutside)
}
componentWillMount() {
  if(!this.state.tokenValid) {
      fetch(`${process.env.REACT_APP_API}/valid`, {
          method: 'post',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
          username: store.getState().user.user.username,
          token: store.getState().user.token
          })
        })
        .then((response)=> {
          response.json()
          .then((data)=>{
            if(data.auth === "false") {
              this.props.onSignin(false)
              this.setState({tokenValid: true})
              localStorage.clear()
              window.location = '/signin'
            }
          })
        })
    }
}
componentWillUnmount() {
  document.removeEventListener('mousedown', this.handleClickOutside);
}
onHighlight = (item) => {
  this.setState({highlight: item})
}
onWebsiteStatus = (status) => {
  this.setState({websiteStatus: status})
}
setWrapperRef(node) {
    this.wrapperRef = node;
}
handleClickOutside(event) {
    if(this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      return;
    }
    else if(!this.state.clickInside)
      this.props.onOpen('')
  }
onMenu = () => {
  if(store.getState().activities.open === 'menu')
  this.props.onOpen('')
  else this.props.onOpen('menu')
}
onClickInside = () => {
  this.setState({clickInside: true})
}
onClickOutside = () => {
  this.setState({clickInside: false})
}
toMake = (text) => {
  this.setState({toMake:text})
}
toHTML = (text) => {
  this.setState({htmlpage:text})
}
  render() {
let {onOpen, onImages, onLinks, onCustomization, onAboutContent, onAboutContentRaw,onWebsiteName, onWebsiteUrl, onWebsiteBio, onTemplate, onRouteChange} = this.props
  if(this.state.tokenValid && !store.getState().user.isSignedIn) {
    return <Redirect href='/signin' to={'/signin'} />
  }
  // if(!store.getState().user.user.verified) {
  //   return <Verify
  //           onMenu={this.onMenu}
  //           menuState={this.state.menu}
  //           onClickInside={this.onClickInside}
  //           onClickOutside={this.onClickOutside}
  //           onOpen={this.props.onOpen}
  //           isDashboard={this.state.isDashboard} 
  //    />
  // }
      else if(this.state.toMake)
            return <Redirect href='/create' to={'/create'} />
      else {
    console.log(this.state.htmlpage)
      return (
          <div className="dash_bg" ref={this.setWrapperRef}>
         <Grid className="dash_bg" fluid={true}>
         <Row>
         <Col lg={9} md={10} sm={10} xs={11} className="dash_nav">
         <Navigation
          onMenu={this.onMenu}
          menuState={this.state.menu}
          onClickInside={this.onClickInside}
          onClickOutside={this.onClickOutside}
          onRouteChange={this.props.onRouteChange}
          onOpen={this.props.onOpen}
          isDashboard={this.state.isDashboard} 
         />
         </Col>
         <Col lg={12} md={12} sm={12} xs={12} className="dash_head">
         <h3 className="temp_headings">Dashboard</h3>
         </Col>
         </Row>
         <Row className="settings">
          <Col lg={2} md={2} sm={12} xs={12}>
          <div className="settings_menu">
          <div className="settings_menu_item_outer"><span className={
            store.getState().user.route === 'dashboard'
            ? 'settings_menu_item settings_menu_item_active'
            : 'settings_menu_item'
          } onClick={()=>this.props.onRouteChange('dashboard')}>Profile</span></div>
          <div className="settings_menu_item_outer"><span className={
            store.getState().user.route === 'settings'
            ? 'settings_menu_item settings_menu_item_active'
            : 'settings_menu_item'
          } onClick={()=>this.props.onRouteChange('settings')}>General</span></div>
          <div className="settings_menu_item_outer"><span className={
            store.getState().user.route === 'password'
            ? 'settings_menu_item settings_menu_item_active'
            : 'settings_menu_item'
          } onClick={()=>this.props.onRouteChange('password')}>Privacy</span></div>
          </div>
          </Col>
          <Col lg={9} md={9} sm={12} xs={12}>
          {store.getState().user.route === 'dashboard'
            ? <WebsiteSettings
            onImages={onImages}
            onLinks={onLinks}
            onCustomization={onCustomization}
            onAboutContent={onAboutContent}
            onAboutContentRaw={onAboutContentRaw}
            onWebsiteName={onWebsiteName}
            onWebsiteUrl={onWebsiteUrl}
            onWebsiteBio={onWebsiteBio}
            onTemplate={onTemplate}
            onRouteChange={onRouteChange}
            onOpen={onOpen}
            toMake={this.toMake}
            onWebsiteStatus={this.onWebsiteStatus}
            websiteStatus={this.state.websiteStatus}
            htmlpage={this.state.htmlpage}
            toHTML={this.toHTML}
            />
            : null
          }
          {store.getState().user.route === 'settings'
            ? <GeneralSettings
              Rolling={Rolling}
              onUser={this.props.onUser}
             />
            : null
          }
          {store.getState().user.route === 'password'
            ? <ChangePassword
              Rolling={Rolling}
              />
            : null
          }
          </Col>
          </Row>
          </Grid>    
          <Grid>
          <Footer />
          </Grid>      
          {store.getState().activities.open === 'menu'
            ? <Menu
            onClickInside={this.onClickInside}
            onClickOutside={this.onClickOutside}
            onRouteChange={this.props.onRouteChange}
            onOpen={this.props.onOpen}
            isDashboard={this.state.isDashboard} />
            : null
          }
          {store.getState().activities.open === 'changetheme'
            ? <ChangeTheme
              onTemplate={onTemplate}
              onClickInside={this.onClickInside}
              onClickOutside={this.onClickOutside}
              onRouteChange={this.props.onRouteChange}
              onWebsiteStatus={this.onWebsiteStatus}
              websiteStatus={this.state.websiteStatus}
              onOpen={onOpen}
              toMake={this.toMake}
              />
            : null
          }
         </div>
      );
    }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);